// export async function searchEntities(url) {
//   const response = await fetch(url)

//   if (!response.ok) {
//     throw new Error('Failed')
//   }

//   return response.json()
// }
import {isSelectableCountry} from '../../../../utils/selectable-countries'

export function fetchSelectedCountryRegionList(countryCode, countryRegionJSON) {
  if (!isSelectableCountry(countryCode)) return []

  const selectedCountry = countryRegionJSON.find(
    country => country.code === countryCode,
  )

  return (selectedCountry?.regions || [])
    .map(region => ({
      label: region.name,
      value: region.code,
    }))
    .sort((a, b) => a.label.localeCompare(b.label))
}

export async function validateAddressAndTZ(run, client, payload) {
  try {
    const response = await run(
      client('accounts/validate/addressAndTZ', {
        method: 'POST',
        data: payload,
      }),
    )

    if (!response?.valid) {
      throw new Error('Address validation failed')
    }

    return response
  } catch (error) {
    throw error?.response?.data || error
  }
}
